import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api";
import config from "../config";
import { formatMoney, formatEventDateTime } from "../utils/format";

/**
 * Compact, embeddable "Get Tickets" card for an event. Designed to be dropped
 * into an <iframe> on an organizer's own website.
 * Route: /embed/event/:slug
 */
export default function EmbedTicket() {
  const { slug } = useParams();
  const [event, setEvent] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/events/${slug}/`, { _noAuth: true })
      .then((r) => setEvent(r.data))
      .catch(() => setError(true));
  }, [slug]);

  if (error) return <div className="p-4 text-sm text-gray-500">Event not available.</div>;
  if (!event) return <div className="p-4 text-sm text-gray-400">Loading…</div>;

  const currency = event.currency || "KES";
  const tiers = (event.ticket_tiers || []).filter((t) => t.is_active !== false);
  let price = "Free";
  if (tiers.length) {
    const min = Math.min(...tiers.map((t) => Number(t.price || 0)));
    price = min > 0 ? `From ${formatMoney(min, currency)}` : "Free";
  } else if (event.is_paid_event && Number(event.ticket_price) > 0) {
    price = formatMoney(event.ticket_price, currency);
  }
  const when = formatEventDateTime(event.date, event.time, event.timezone);
  const eventUrl = `${window.location.origin}/events/${event.slug}`;
  const img = event.thumbnail_photo
    ? (String(event.thumbnail_photo).startsWith("http") ? event.thumbnail_photo : `${config.MEDIA_BASE_URL}${event.thumbnail_photo}`)
    : null;

  return (
    <div className="p-3 bg-transparent">
      <div className="max-w-sm mx-auto bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
        {img && <img src={img} alt={event.title} className="w-full h-32 object-cover" />}
        <div className="p-4">
          <h3 className="font-bold text-gray-900 text-lg leading-tight line-clamp-2">{event.title}</h3>
          <p className="text-sm text-gray-500 mt-1">{when.full}</p>
          <p className="text-sm text-gray-500">{event.location}</p>
          <div className="flex items-center justify-between mt-4">
            <span className="font-bold text-indigo-600">{price}</span>
            <a
              href={eventUrl}
              target="_top"
              className="px-4 py-2 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-sm font-semibold hover:from-indigo-700 hover:to-purple-700"
            >
              Get Tickets
            </a>
          </div>
          <p className="text-[10px] text-gray-400 text-center mt-3">Powered by EventSawa</p>
        </div>
      </div>
    </div>
  );
}
